import { IGetAffiliateProfileParams } from "../../../store/api/affiliatesProfileApiSlice";
import {
  QUERY_PARAM_FILTER_USER_ID,
  QUERY_PARAM_SORT_DIRECTION,
  QUERY_PARAM_SORT_FIELD,
} from "../../portfolio/constants";
import {
  DEFAULT_DATE_RANGE_END,
  DEFAULT_DATE_RANGE_START,
  DEFAULT_LEAD_STATUS,
  DEFAULT_SORT_DIRECTION,
  DEFAULT_SORT_FIELD,
  QUERY_PARAM_DATE_RANGE_END,
  QUERY_PARAM_DATE_RANGE_START,
  QUERY_PARAM_LEAD_STATUS,
} from "./contants";

export function parseSearchParams(
  searchParams: URLSearchParams,
  userId: string
): IGetAffiliateProfileParams {
  const sortFieldParam = searchParams.get(QUERY_PARAM_SORT_FIELD);
  const leadStatusParam = searchParams.get(QUERY_PARAM_LEAD_STATUS);
  const userIdParam = searchParams.get(QUERY_PARAM_FILTER_USER_ID);
  const sortDirectionParam = searchParams.get(QUERY_PARAM_SORT_DIRECTION);

  const dateRangeStartParam = searchParams.get(QUERY_PARAM_DATE_RANGE_START);
  const dateRangeEndParam = searchParams.get(QUERY_PARAM_DATE_RANGE_END);
  return {
    sort: {
      direction: sortDirectionParam || DEFAULT_SORT_DIRECTION,
      field: sortFieldParam || DEFAULT_SORT_FIELD,
    },
    userId: userIdParam || userId,
    leadStatus: leadStatusParam || DEFAULT_LEAD_STATUS,
    dateRange: {
      start: dateRangeStartParam || DEFAULT_DATE_RANGE_START,
      end: dateRangeEndParam || DEFAULT_DATE_RANGE_END,
    },
  };
}

export function buildSearchParamsFromGetPropertiesParams(
  params: IGetAffiliateProfileParams
): URLSearchParams {
  const queryParams = new URLSearchParams();

  queryParams.set(QUERY_PARAM_SORT_DIRECTION, params.sort.direction);
  queryParams.set(QUERY_PARAM_SORT_FIELD, params.sort.field);
  queryParams.set(QUERY_PARAM_LEAD_STATUS, params.leadStatus);
  queryParams.set(QUERY_PARAM_FILTER_USER_ID, params.userId);

  queryParams.set(QUERY_PARAM_DATE_RANGE_START, params.dateRange.start);
  queryParams.set(QUERY_PARAM_DATE_RANGE_END, params.dateRange.end);

  return queryParams;
}
